import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList } from "vue";
const _hoisted_1 = {
    class: "ws__work",
    "aria-label": "Prior authorization"
};
const _hoisted_2 = {
    key: 0,
    class: "ws__viewing"
};
const _hoisted_3 = {
    key: 1,
    class: "ws__narrowbar"
};
const _hoisted_4 = {
    key: 0,
    class: "ws__count"
};
const _hoisted_5 = { class: "ws__pane-inner" };
const _hoisted_6 = {
    key: 0,
    class: "ws__outgoing"
};
const _hoisted_7 = {
    key: 1,
    class: "ws__loading"
};
const _hoisted_8 = { class: "ws__topline" };
const _hoisted_9 = {
    class: "ws__topline-actions",
    "data-tour": "view"
};
const _hoisted_10 = { class: "ws__main" };
const _hoisted_11 = {
    class: "ws__bar",
    "aria-label": "Owners"
};
const _hoisted_12 = { class: "ws__bar-row" };
const _hoisted_13 = { class: "ws__bar-owners" };
const _hoisted_14 = {
    class: "ws__section",
    "data-tour": "attention",
    "aria-labelledby": "ws-attention-title"
};
const _hoisted_15 = { class: "ws__section-head" };
const _hoisted_16 = {
    key: 0,
    class: "ws__count ws__count--hot"
};
const _hoisted_17 = {
    key: 1,
    class: "ws__section-note"
};
const _hoisted_18 = {
    key: 2,
    class: "ws__section-progress"
};
const _hoisted_19 = { class: "ws__group" };
const _hoisted_20 = {
    class: "ws__section",
    "data-tour": "full-pa",
    "aria-labelledby": "ws-full-title"
};
const _hoisted_21 = { class: "ws__form" };
const _hoisted_22 = {
    id: "ws-activity",
    class: "ws__section ws__activity",
    "aria-labelledby": "ws-activity-title"
};
const _hoisted_23 = { class: "ws__bar" };
const _hoisted_24 = { class: "ws__bar-row" };
const _hoisted_25 = { class: "ws__bar-owners" };
const _hoisted_26 = ["aria-valuenow"];
const _hoisted_27 = {
    key: 0,
    class: "ws__tab-count"
};
const _hoisted_28 = { class: "ws__keys" };
const _hoisted_29 = { class: "ws__keys-grid" };
const _hoisted_30 = { class: "ws__keys-keys" };
const _hoisted_31 = { class: "ws__keys-foot" };
import { computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import PriorFooter from "@/components/PriorFooter.vue";
import PaActionBar from "@/components/paWorkspace/PaActionBar.vue";
import PaRecap from "@/components/paWorkspace/PaRecap.vue";
import PaTour from "@/components/paWorkspace/PaTour.vue";
import PaViewSwitch from "@/components/paWorkspace/PaViewSwitch.vue";
import { IS_MAC, MOD_KEY } from "@/utils/platformKeys";
import DocumentViewer from "@/components/paWorkspace/DocumentViewer.vue";
import { usePaWorkspaceStore } from "@/stores/paWorkspaceStore";
import { useDocumentWindow } from "@/composables/useDocumentWindow";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaWorkspace',
    props: {
        order: {},
        loading: { type: Boolean },
        viewerMode: { type: Boolean, default: false },
        viewerText: { default: "" },
        canTakeOver: { type: Boolean, default: false },
        attention: { default: () => [] },
        actions: { default: () => ({}) },
        since: { default: null },
        saveState: { default: "saved" }
    },
    emits: ["back", "send-plan", "send-prescriber", "save-draft", "archive", "unarchive", "classic", "take-over", "reveal-question"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const SHORTCUTS = [
            { keys: ["J"], label: "Next flagged question" },
            { keys: ["K"], label: "Previous flagged question" },
            { keys: ["Enter"], label: "Confirm the focused AI answer" },
            { keys: [MOD_KEY, "F"], label: "Search the documents" },
            { keys: ["D"], label: "Show or hide the documents" },
            { keys: ["\\"], label: "Move the documents to the other side" },
            { keys: [MOD_KEY, "Enter"], label: "Send to plan" },
            { keys: ["?"], label: "Show these shortcuts" },
        ];
        const workspace = usePaWorkspaceStore();
        const { layout } = storeToRefs(workspace);
        const tourRef = ref(null);
        const tourOpen = ref(false);
        const rootEl = ref(null);
        const bodyEl = ref(null);
        const paneEl = ref(null);
        const viewerRef = ref(null);
        const shortcutsOpen = ref(false);
        const drawerOpen = ref(false);
        const narrow = ref(false);
        const documents = ref([]);
        const orderKey = computed(() => props.order?.orderKey ?? null);
        const documentsOrderKey = ref(null);
        watch(orderKey, (key) => {
            if (key)
                documentsOrderKey.value = key;
        }, { immediate: true });
        const recapOpen = ref(true);
        const totalFlagged = computed(() => props.attention.length);
        const openFlagged = computed(() => props.attention.filter((item) => item.open).length);
        const documentCount = computed(() => documents.value.length);
        const docWindow = useDocumentWindow(orderKey, computed(() => [props.order?.patientFirstName, props.order?.patientLastName].filter(Boolean).join(" ")), () => {
            if (layout.value.docMode === "window")
                layout.value.docMode = "docked";
        });
        const effectiveDocMode = computed(() => {
            if (layout.value.docMode === "window" && docWindow.open.value)
                return "window";
            if (narrow.value)
                return "drawer";
            return layout.value.docMode === "hidden" ? "hidden" : "docked";
        });
        let pendingDocumentKey = null;
        function onDocumentsLoaded() {
            documents.value = viewerRef.value?.documents ?? [];
            scrollToPendingDocument();
        }
        function openDocument(key) {
            showDocuments();
            pendingDocumentKey = key;
            nextTick(scrollToPendingDocument);
        }
        function scrollToPendingDocument() {
            const key = pendingDocumentKey;
            const loaded = viewerRef.value?.documents ?? [];
            if (!key || !loaded.some((document) => document.key === key))
                return;
            pendingDocumentKey = null;
            nextTick(() => viewerRef.value?.scrollToPage(key, 1));
        }
        function showDocuments() {
            if (narrow.value)
                drawerOpen.value = true;
            else
                layout.value.docMode = "docked";
        }
        function hideDocuments() {
            if (narrow.value)
                drawerOpen.value = false;
            else
                layout.value.docMode = "hidden";
        }
        function swapSide() {
            layout.value.docSide = layout.value.docSide === "right" ? "left" : "right";
        }
        function popOut() {
            if (docWindow.popOut())
                layout.value.docMode = "window";
        }
        function bringBack() {
            docWindow.dock();
            layout.value.docMode = "docked";
        }
        let resizing = false;
        function startResize(event) {
            resizing = true;
            event.target.setPointerCapture(event.pointerId);
            document.body.classList.add("ws-resizing");
            const move = (e) => {
                if (!resizing || !bodyEl.value)
                    return;
                const rect = bodyEl.value.getBoundingClientRect();
                const fromRight = ((rect.right - e.clientX) / rect.width) * 100;
                const pct = layout.value.docSide === "right" ? fromRight : 100 - fromRight;
                layout.value.docWidth = Math.round(Math.min(66, Math.max(28, pct)));
            };
            const stop = () => {
                resizing = false;
                document.body.classList.remove("ws-resizing");
                window.removeEventListener("pointermove", move);
                window.removeEventListener("pointerup", stop);
            };
            window.addEventListener("pointermove", move);
            window.addEventListener("pointerup", stop);
        }
        function nudge(delta) {
            layout.value.docWidth = Math.min(66, Math.max(28, layout.value.docWidth + delta));
        }
        function flaggedElements() {
            if (!paneEl.value)
                return [];
            const root = paneEl.value.querySelector("#ws-attention-questions") ?? paneEl.value;
            return Array.from(root.querySelectorAll(".ws-q--flagged")).filter((el) => el.offsetParent !== null);
        }
        function attentionCopy(el, all) {
            const card = el?.closest(".ws-q--flagged");
            if (!card)
                return null;
            return all.includes(card)
                ? card
                : all.find((item) => item.dataset.attentionKey === card.dataset.attentionKey) ?? null;
        }
        function focusFlagged(direction) {
            const all = flaggedElements();
            const open = all.filter((el) => el.classList.contains("ws-q--open"));
            const items = open.length ? open : all;
            if (!items.length)
                return;
            const current = attentionCopy(document.activeElement, all);
            if (!current) {
                focusElement(direction > 0 ? items[0] : items[items.length - 1]);
                return;
            }
            const at = all.indexOf(current);
            const ahead = direction > 0 ? all.slice(at + 1) : all.slice(0, at).reverse();
            focusElement(ahead.find((el) => items.includes(el)) ?? current);
        }
        function focusElement(el) {
            paneEl.value?.querySelectorAll(".ws-q--focus").forEach((item) => item.classList.remove("ws-q--focus"));
            el.classList.add("ws-q--focus");
            el.focus({ preventScroll: true });
            el.scrollIntoView({ block: "center", behavior: "smooth" });
        }
        __expose({ focusElement });
        function confirmFocused() {
            const active = document.activeElement;
            const current = active?.classList.contains("ws-q--flagged") ? active : null;
            const button = current?.querySelector("[data-ws-confirm]");
            if (!current || !button || button.hasAttribute("disabled"))
                return false;
            const anchor = attentionCopy(current, flaggedElements());
            button.click();
            nextTick(() => {
                const items = flaggedElements();
                const from = anchor ? items.indexOf(anchor) : -1;
                const next = items.slice(from + 1).find((el) => el.classList.contains("ws-q--open"));
                if (next)
                    focusElement(next);
            });
            return true;
        }
        function sendToPlan() {
            emit("send-plan");
        }
        function isTyping(target) {
            const el = target;
            if (!el)
                return false;
            return Boolean(el.closest("input:not([type='radio']):not([type='checkbox']), textarea, select, [contenteditable='true'], .v-field"));
        }
        function scrollToActivity() {
            rootEl.value?.querySelector("#ws-activity")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        function overlayOpen() {
            return Boolean(document.querySelector(".v-overlay--active .v-dialog, .v-overlay--active.v-dialog"));
        }
        function onKeydown(event) {
            if (tourOpen.value || shortcutsOpen.value || overlayOpen())
                return;
            const mod = IS_MAC ? event.metaKey : event.ctrlKey;
            if (mod && event.key === "Enter") {
                const el = event.target;
                if (el?.closest?.("textarea, [contenteditable='true'], .ws__activity, .ws__outgoing"))
                    return;
                event.preventDefault();
                if (!event.repeat && !props.viewerMode)
                    sendToPlan();
                return;
            }
            if (mod && event.key.toLowerCase() === "f" && effectiveDocMode.value !== "window") {
                event.preventDefault();
                showDocuments();
                nextTick(() => viewerRef.value?.focusSearch());
                return;
            }
            if (event.metaKey || event.ctrlKey || event.altKey || isTyping(event.target))
                return;
            switch (event.key) {
                case "j":
                    event.preventDefault();
                    focusFlagged(1);
                    break;
                case "k":
                    event.preventDefault();
                    focusFlagged(-1);
                    break;
                case "Enter":
                    if (confirmFocused())
                        event.preventDefault();
                    break;
                case "d":
                    if (effectiveDocMode.value === "docked" || (narrow.value && drawerOpen.value))
                        hideDocuments();
                    else
                        showDocuments();
                    break;
                case "\\":
                    swapSide();
                    break;
                case "?":
                    shortcutsOpen.value = true;
                    break;
            }
        }
        let resizeObserver = null;
        onBeforeMount(() => {
            workspace.ownsFooter = true;
        });
        onMounted(() => {
            window.addEventListener("keydown", onKeydown);
            resizeObserver = new ResizeObserver(([entry]) => {
                narrow.value = entry.contentRect.width < 1100;
            });
            if (rootEl.value)
                resizeObserver.observe(rootEl.value);
        });
        onBeforeUnmount(() => {
            workspace.ownsFooter = false;
            window.removeEventListener("keydown", onKeydown);
            resizeObserver?.disconnect();
        });
        watch(documentsOrderKey, (key, previous) => {
            if (!key || key === previous)
                return;
            drawerOpen.value = false;
            recapOpen.value = true;
            pendingDocumentKey = null;
            documents.value = [];
            paneEl.value?.scrollTo({ top: 0 });
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "rootEl",
                ref: rootEl,
                class: _normalizeClass(["ws dash-page", [`ws--docs-${effectiveDocMode.value}`, `ws--side-${_unref(layout).docSide}`, { 'ws--narrow': narrow.value }]])
            }, [
                _createElementVNode("div", {
                    ref_key: "bodyEl",
                    ref: bodyEl,
                    class: "ws__body",
                    style: _normalizeStyle({ '--doc-width': `${_unref(layout).docWidth}%` })
                }, [
                    _createElementVNode("section", _hoisted_1, [
                        (__props.viewerMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                            _createTextVNode("mdi-account-lock-outline", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createElementVNode("span", null, _toDisplayString(__props.viewerText), 1),
                                (__props.canTakeOver)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        size: "small",
                                        variant: "flat",
                                        color: "primary",
                                        rounded: "lg",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('take-over')))
                                    }, {
                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                _createTextVNode(" Take over editing ", -1)
                                            ]))]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (narrow.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("button", {
                                    class: "ws__docs-btn",
                                    "data-tour": "documents",
                                    "data-tour-variant": "drawer",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (drawerOpen.value = !drawerOpen.value))
                                }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                _createTextVNode("mdi-file-document-multiple-outline", -1)
                                            ]))]),
                                        _: 1
                                    }),
                                    _cache[22] || (_cache[22] = _createTextVNode(" Documents", -1)),
                                    (documentCount.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(documentCount.value), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            ref_key: "paneEl",
                            ref: paneEl,
                            class: "ws__pane"
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _renderSlot(_ctx.$slots, "banners"),
                                (_ctx.$slots.outgoing)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _renderSlot(_ctx.$slots, "outgoing")
                                    ]))
                                    : _createCommentVNode("", true),
                                (__props.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[23] || (_cache[23] = [
                                            _createElementVNode("div", { class: "ws__skeleton ws__skeleton--brief" }, null, -1),
                                            _createElementVNode("div", { class: "ws__skeleton" }, null, -1),
                                            _createElementVNode("div", { class: "ws__skeleton" }, null, -1)
                                        ]))]))
                                    : (__props.order)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "ws__whatsnew",
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (tourRef.value?.start()))
                                                    }, [
                                                        _createVNode(_component_v_icon, { size: "15" }, {
                                                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                                    _createTextVNode("mdi-creation-outline", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[25] || (_cache[25] = _createTextVNode(" What's new ", -1))
                                                    ]),
                                                    _createVNode(PaViewSwitch, {
                                                        "model-value": "new",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = (view) => view === 'classic' && emit('classic'))
                                                    })
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _renderSlot(_ctx.$slots, "details")
                                            ]),
                                            _createElementVNode("section", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _renderSlot(_ctx.$slots, "owners", { placement: "top" })
                                                    ]),
                                                    _createElementVNode("button", {
                                                        class: "ws__bar-toggle",
                                                        "data-tour": "activity",
                                                        "aria-controls": "ws-activity",
                                                        onClick: scrollToActivity
                                                    }, [
                                                        _createVNode(_component_v_icon, { size: "16" }, {
                                                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                                    _createTextVNode("mdi-history", -1)
                                                                ]))]),
                                                            _: 1
                                                        }),
                                                        _cache[28] || (_cache[28] = _createTextVNode(" Activity ", -1)),
                                                        _createVNode(_component_v_icon, { size: "16" }, {
                                                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                                    _createTextVNode("mdi-arrow-down", -1)
                                                                ]))]),
                                                            _: 1
                                                        })
                                                    ])
                                                ])
                                            ]),
                                            _createVNode(PaRecap, {
                                                open: recapOpen.value,
                                                "onUpdate:open": _cache[4] || (_cache[4] = ($event) => ((recapOpen).value = $event)),
                                                class: "ws__recap",
                                                "data-tour": "recap",
                                                "order-key": orderKey.value,
                                                onOpenDocument: openDocument,
                                                onRevealQuestion: _cache[5] || (_cache[5] = (id) => emit('reveal-question', id))
                                            }, null, 8, ["open", "order-key"]),
                                            _createElementVNode("section", _hoisted_14, [
                                                _createElementVNode("header", _hoisted_15, [
                                                    _cache[29] || (_cache[29] = _createElementVNode("h2", {
                                                        id: "ws-attention-title",
                                                        class: "ws__section-title"
                                                    }, "Needs attention", -1)),
                                                    (openFlagged.value)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(openFlagged.value), 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "Nothing open")),
                                                    (totalFlagged.value)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(totalFlagged.value - openFlagged.value) + " of " + _toDisplayString(totalFlagged.value) + " reviewed ", 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _withDirectives(_createElementVNode("div", _hoisted_19, [...(_cache[30] || (_cache[30] = [
                                                        _createElementVNode("div", {
                                                            id: "ws-attention-questions",
                                                            class: "ws__pinned"
                                                        }, null, -1)
                                                    ]))], 512), [
                                                    [_vShow, totalFlagged.value]
                                                ])
                                            ]),
                                            _createElementVNode("section", _hoisted_20, [
                                                _cache[31] || (_cache[31] = _createElementVNode("header", { class: "ws__section-head" }, [
                                                    _createElementVNode("h2", {
                                                        id: "ws-full-title",
                                                        class: "ws__section-title"
                                                    }, "Full PA")
                                                ], -1)),
                                                _renderSlot(_ctx.$slots, "review"),
                                                _createElementVNode("div", _hoisted_21, [
                                                    _renderSlot(_ctx.$slots, "form", { attentionTarget: "#ws-attention-questions" })
                                                ])
                                            ]),
                                            _createElementVNode("section", _hoisted_22, [
                                                _cache[32] || (_cache[32] = _createElementVNode("header", { class: "ws__section-head" }, [
                                                    _createElementVNode("h2", {
                                                        id: "ws-activity-title",
                                                        class: "ws__section-title"
                                                    }, "Activity")
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _renderSlot(_ctx.$slots, "owners", { placement: "bottom" })
                                                        ])
                                                    ])
                                                ]),
                                                _renderSlot(_ctx.$slots, "activity")
                                            ])
                                        ], 64))
                                        : _createCommentVNode("", true)
                            ]),
                            _createVNode(PriorFooter, { class: "ws__footer" })
                        ], 512),
                        (__props.order)
                            ? (_openBlock(), _createBlock(PaActionBar, {
                                key: 2,
                                actions: __props.actions,
                                "save-state": __props.saveState,
                                "viewer-mode": __props.viewerMode,
                                onBack: _cache[6] || (_cache[6] = ($event) => (emit('back'))),
                                onSendPlan: sendToPlan,
                                onSendPrescriber: _cache[7] || (_cache[7] = ($event) => (emit('send-prescriber'))),
                                onSaveDraft: _cache[8] || (_cache[8] = ($event) => (emit('save-draft'))),
                                onArchive: _cache[9] || (_cache[9] = ($event) => (emit('archive'))),
                                onUnarchive: _cache[10] || (_cache[10] = ($event) => (emit('unarchive'))),
                                onShortcuts: _cache[11] || (_cache[11] = ($event) => (shortcutsOpen.value = true))
                            }, null, 8, ["actions", "save-state", "viewer-mode"]))
                            : _createCommentVNode("", true)
                    ]),
                    (effectiveDocMode.value === 'docked')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "ws__split",
                            role: "separator",
                            "aria-orientation": "vertical",
                            "aria-label": "Resize documents",
                            tabindex: "0",
                            "aria-valuenow": _unref(layout).docWidth,
                            onPointerdown: startResize,
                            onKeydown: [
                                _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event) => (nudge(_unref(layout).docSide === 'right' ? 2 : -2)), ["prevent"]), ["left"])),
                                _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event) => (nudge(_unref(layout).docSide === 'right' ? -2 : 2)), ["prevent"]), ["right"]))
                            ]
                        }, null, 40, _hoisted_26))
                        : _createCommentVNode("", true),
                    (narrow.value && drawerOpen.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "ws__scrim",
                            onClick: _cache[14] || (_cache[14] = ($event) => (drawerOpen.value = false))
                        }))
                        : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("section", {
                        class: _normalizeClass(["ws__docs", { 'ws__docs--drawer': narrow.value }]),
                        "data-tour": "documents"
                    }, [
                        _createVNode(DocumentViewer, {
                            ref_key: "viewerRef",
                            ref: viewerRef,
                            "rail-open": _unref(layout).railOpen,
                            "onUpdate:railOpen": _cache[15] || (_cache[15] = ($event) => ((_unref(layout).railOpen) = $event)),
                            mode: narrow.value ? 'drawer' : 'docked',
                            "order-key": documentsOrderKey.value,
                            since: __props.since,
                            onLoaded: onDocumentsLoaded,
                            onSwap: swapSide,
                            onPopout: popOut,
                            onHide: hideDocuments
                        }, null, 8, ["rail-open", "mode", "order-key", "since"])
                    ], 2), [
                        [_vShow, effectiveDocMode.value === 'docked' || (narrow.value && drawerOpen.value)]
                    ]),
                    (effectiveDocMode.value === 'hidden')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "ws__docs-tab",
                            "data-tour": "documents",
                            "data-tour-variant": "hidden",
                            onClick: showDocuments
                        }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                        _createTextVNode("mdi-file-document-multiple-outline", -1)
                                    ]))]),
                                _: 1
                            }),
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "Documents", -1)),
                            (documentCount.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(documentCount.value), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (effectiveDocMode.value === 'window')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: "ws__docs-tab ws__docs-tab--away",
                            "data-tour": "documents",
                            "data-tour-variant": "window",
                            title: "Documents are in a second window and follow this PA. Click to bring them back.",
                            onClick: bringBack
                        }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                        _createTextVNode("mdi-open-in-new", -1)
                                    ]))]),
                                _: 1
                            }),
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "Documents in second window", -1))
                        ]))
                        : _createCommentVNode("", true)
                ], 4),
                _createVNode(PaTour, {
                    ref_key: "tourRef",
                    ref: tourRef,
                    root: rootEl.value,
                    "onUpdate:open": _cache[16] || (_cache[16] = (value) => (tourOpen.value = value))
                }, null, 8, ["root"]),
                _createVNode(_component_v_dialog, {
                    modelValue: shortcutsOpen.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((shortcutsOpen).value = $event)),
                    "max-width": "520"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                            _cache[38] || (_cache[38] = _createElementVNode("h2", null, "Keyboard shortcuts", -1)),
                            _createElementVNode("div", _hoisted_29, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SHORTCUTS, (row) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: row.label
                                    }, [
                                        _createElementVNode("span", _hoisted_30, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.keys, (key) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: key,
                                                    class: "ws__kbd"
                                                }, _toDisplayString(key), 1));
                                            }), 128))
                                        ]),
                                        _createElementVNode("span", null, _toDisplayString(row.label), 1)
                                    ], 64));
                                }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_v_btn, {
                                    variant: "text",
                                    rounded: "lg",
                                    onClick: _cache[17] || (_cache[17] = ($event) => (shortcutsOpen.value = false))
                                }, {
                                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                            _createTextVNode("Close", -1)
                                        ]))]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 2));
        };
    }
});
